module.exports = __webpack_public_path__ + "fonts/almoni-bold-aaa.cc37ce7.woff";